__webpack_require__.p = "https://bmm.mca.nsu.ru/";